export const opcoesPrazoRendaTemporaria = [
  { value: '10', label: '10 anos' },
  { value: '15', label: '15 anos' },
  { value: '20', label: '20 anos' },
];
